import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Trans } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { DatePicker } from "@material-ui/pickers";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";

const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});

export class AddFilter extends Component {
  state = {
    filterName: "",
    filterValue: null,
    text: "",
    type: "Text",
    boolean: false,
    date: null,
  };
  dateChange = (e) => {
    this.setState({ date: e });
  };
  render() {
    const { classes, ...withoutClasses } = this.props;
    return (
      <>
        <FormLabel>Add parameter</FormLabel>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormControl component="fieldset" className={classes.formControl}>
            <TextField
              label="Name"
              // id="outlined-size-small"
              // variant="outlined"
              // size="small"
              onChange={(e) => this.setState({ filterName: e.target.value })}
            />
          </FormControl>
          <FormControl component="fieldset" className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Data type</InputLabel>
            <Select
              value={this.state.type}
              onChange={(event) => this.setState({ type: event.target.value })}
            >
              <MenuItem key="fontSize" value={"Text"}>
                Text
              </MenuItem>
              <MenuItem key="fontSize" value={"Date"}>
                Date
              </MenuItem>
              <MenuItem key="fontSize" value={"Boolean"}>
                Boolean
              </MenuItem>
            </Select>
          </FormControl>
          <FormControl component="fieldset" className={classes.formControl}>
            {this.state.type === "Text" ? (
              <TextField
                label="Value"
                // id="outlined-size-small"
                // variant="outlined"
                // size="small"
                onChange={(e) => this.setState({ text: e.target.value })}
              />
            ) : this.state.type === "Date" ? (
              <DatePicker
                autoOk
                label={"Value"}
                clearable
                disableFuture
                value={this.state.date}
                onChange={this.dateChange}
              />
            ) : (
              <FormControlLabel
                style={{ marginTop: "10px" }}
                value="bold"
                control={
                  <Checkbox
                    checked={this.state.boolean}
                    onChange={(event) =>
                      this.setState({ boolean: event.target.checked })
                    }
                    value="primary"
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                }
                label={"Value"}
              />
            )}
          </FormControl>
          <Button
            onClick={() =>
              this.props.handleAddFilter({
                filterName: this.state.filterName,
                filterValue:
                  this.state.type === "Text"
                    ? this.state.text
                    : this.state.type === "Boolean"
                      ? this.state.boolean
                      : this.state.date,
              })
            }
            color="primary"
            variant="outlined"
          >
            Add parameter
          </Button>
        </div>
      </>
    );
  }
}

export default withStyles(styles)(AddFilter);
